module.exports = {
	"ha": "viha",
	"id": 5.7,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2022 Q1–2023 Q4",
		"lastYear": "2023",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 60,
			"marginLeft": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 5.7</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Island Health by HSDA, Year Ending 2023 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -140,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 98.0327868852459,
						"dataLabels": {
							"enabled": true,
							"format": "299"
						}
					},
					{
						"y": 98.0327868852459,
						"dataLabels": {
							"enabled": true,
							"format": "299"
						}
					},
					{
						"y": 95.08196721311475,
						"dataLabels": {
							"enabled": true,
							"format": "290"
						}
					},
					{
						"y": 89.8360655737705,
						"dataLabels": {
							"enabled": true,
							"format": "274"
						}
					},
					{
						"y": 70.16393442622952,
						"dataLabels": {
							"enabled": true,
							"format": "214"
						}
					},
					{
						"y": null
					},
					{
						"y": 99.11504424778761,
						"dataLabels": {
							"enabled": true,
							"format": "112"
						}
					},
					{
						"y": 99.11504424778761,
						"dataLabels": {
							"enabled": true,
							"format": "112"
						}
					},
					{
						"y": 99.11504424778761,
						"dataLabels": {
							"enabled": true,
							"format": "112"
						}
					},
					{
						"y": 93.80530973451327,
						"dataLabels": {
							"enabled": true,
							"format": "106"
						}
					},
					{
						"y": 58.4070796460177,
						"dataLabels": {
							"enabled": true,
							"format": "66"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.55043227665706,
						"dataLabels": {
							"enabled": true,
							"format": "677"
						}
					},
					{
						"y": 93.65994236311239,
						"dataLabels": {
							"enabled": true,
							"format": "650"
						}
					},
					{
						"y": 90.48991354466858,
						"dataLabels": {
							"enabled": true,
							"format": "628"
						}
					},
					{
						"y": 84.72622478386167,
						"dataLabels": {
							"enabled": true,
							"format": "588"
						}
					},
					{
						"y": 60.80691642651297,
						"dataLabels": {
							"enabled": true,
							"format": "422"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -1.967213114754096,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.0100334448160515,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.517241379310345,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.897810218978098,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.8849557522123908,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.35714285714286,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -37.735849056603776,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.449567723342938,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.9881831610044327,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.384615384615386,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.369426751592355,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -28.2312925170068,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "Central Vancouver Island<br>n=305"
			},
			{
				"x": 9,
				"text": "North Vancouver Island<br>n=113"
			},
			{
				"x": 15,
				"text": "South Vancouver Island<br>n=694"
			}
		],
		"dataTable": {
			"Central Vancouver Island": [
				305,
				299,
				299,
				290,
				274,
				214
			],
			"North Vancouver Island": [
				113,
				112,
				112,
				112,
				106,
				66
			],
			"South Vancouver Island": [
				694,
				677,
				650,
				628,
				588,
				422
			]
		}
	},
	"callback": "C:\\Git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_5_7.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_viha_5_7.json
// module id = 342
// module chunks = 0